import React from 'react'

import { Banner, Button, FeatureBadge, Text, useToast } from '@driftt/dds'
import { tracking } from '@driftt/traffic-control'

import useLocalStorage from 'hooks/useLocalStorage'

export const AudiencesBanner = () => {
  const triggerToast = useToast()
  const [showBetaBanner, setShowBanner] = useLocalStorage(
    'showAudiencesEAPBanner',
    true
  )

  const handleSignUp = () => {
    triggerToast({
      message:
        'Sign up successful! You will be notified when the report is ready.',
      variant: 'success',
    })
    tracking.trackEvent('Audiences EAP Sign-up Clicked')
  }

  return (
    <>
      {showBetaBanner && (
        <Banner.Root
          variant="new"
          onClose={() => setShowBanner(false)}
          rootProps={{ id: 'audiences-report--eap-beta-banner' }}
          css={{ minHeight: '52px' }}
        >
          <Banner.Content>
            <FeatureBadge variant="new" />
            <Text as="span" variant="body">
              We're working on a new report for <b>Audiences</b>! Please sign up
              for our Early Access Program if you're interested.
            </Text>
          </Banner.Content>
          <Banner.Actions>
            <Button variant="tertiary" onClick={handleSignUp}>
              Sign up
            </Button>
          </Banner.Actions>
        </Banner.Root>
      )}
    </>
  )
}
